// extracted by mini-css-extract-plugin
export var columnList = "_e2-0";